






























































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class PersonalInformationAgreeModal extends Vue {
  isVisible: boolean = true;

  onClose() {
    this.isVisible = false;
    this.$emit('input', null);
  }

  onPersonalInfomationAgreeYn(personalInfomationAgreeYn: boolean) {
    this.isVisible = false;
    this.$emit('onPersonalInfomationAgreeYn', personalInfomationAgreeYn);
    this.$emit('input', null);
  }
}
